import axios from "axios";
import * as vars from "./vars";

export function getBlogPosts (getBlogPostRequest, jwt = undefined) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/blogging/GetBlogPosts',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getBlogPostRequest
    })
}

export function  getRecommendedBlogs (uri, deviceId, jwt = undefined) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/blogging/GetRecommendedBlogs',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {uri: uri, deviceId: deviceId}
    })
}

export function getBlogPostComments (getBlogCommentsRequest) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/blogging/GetBlogPostComments',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: getBlogCommentsRequest
    })
}

export function addBlogPostComment (addBlogPostCommentRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/blogging/AddBlogPostComment',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: addBlogPostCommentRequest
    })
}

export function addBlogPostCommentReply (addBlogPostCommentReplyRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/blogging/AddBlogPostCommentReply',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: addBlogPostCommentReplyRequest
    })
}

export function getBlogPostLikeCount (uri, deviceId) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/blogging/GetBlogPostLikeCount',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {uri: uri, deviceId: deviceId}
    })
}

export function toggleBlogPostLike (uri, deviceId, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/blogging/ToggleBlogPostLike',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {uri: uri, deviceId: deviceId}
    })
}
